export default function () {
  let window = `relatorio.leiloes.leiloes`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relatório de Leilões',
    width: '600',
    height: '450',
    minHeight: '500px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./RelatorioLeiloesWindow.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
